import { ContainerModule } from 'inversify';
import ReviewsService from 'src/features/reviews/data/service/ReviewsService';
import { ReviewsServiceInterface } from 'src/features/reviews/data/service/ReviewsService.types';
import SendOrderReviewUseCase from 'src/features/reviews/domain/useCases/SendOrderReviewUseCase';
import DismissReviewUseCase from 'src/features/reviews/domain/useCases/DismissReviewUseCase';
import GetPendingReviewUseCase from 'src/features/reviews/domain/useCases/GetPendingReviewUseCase';

export const reviewsBindings = new ContainerModule((bind) => {
  bind<ReviewsServiceInterface>(ReviewsService).to(ReviewsService);
  bind<SendOrderReviewUseCase>(SendOrderReviewUseCase).to(
    SendOrderReviewUseCase
  );
  bind<DismissReviewUseCase>(DismissReviewUseCase).to(DismissReviewUseCase);
  bind<GetPendingReviewUseCase>(GetPendingReviewUseCase).to(
    GetPendingReviewUseCase
  );
});
